import React from 'react';

import { css, cx } from '@emotion/css';
import { Drawer } from '@mui/material';

import { useStyles } from '@/hooks/useStyles.ts';
import { AtomProps, StyleClasses } from '@/uiKit/atoms/utils/AtomTypes.ts';

type BaseSideSheetProps = {
  open: boolean;
  onClose: () => void;
  children?: React.ReactNode;
};

export type SideSheetProps = AtomProps<
  BaseSideSheetProps,
  StyleClasses<'drawer' | 'paper' | 'container'>
>;

export const SideSheet: React.FC<SideSheetProps> = ({
  open,
  onClose,
  children,
  classes,
  className,
}) => {
  const styles = useStyles(makeStyles);
  return (
    <Drawer
      open={open}
      anchor="right"
      onClose={onClose}
      className={cx(className, classes?.drawer)}
      classes={{ paper: cx(styles.paper, classes?.paper) }}
    >
      <div className={cx(styles.container, classes?.container)}>{children}</div>
    </Drawer>
  );
};

const makeStyles = () => ({
  paper: css({
    overflowX: 'clip',
  }),
  container: css({
    display: 'flex',
    flexDirection: 'column',
    width: 'min(600px, 100vw)',
    height: '100%',
    overflow: 'clip',
  }),
});
